import { ApolloError } from '@apollo/client';

import { useCreateMessagingCampaign } from '@occc-app/dataAccessLayer/messagingCenter/mutations';
import { CreateMessagingCampaignMutation } from '@occc/graphql';
import { getUpdateChannelsConfigInput } from '@occc/ui-notifications';

import { MessagingCampaignConfigureFormValues } from '../messaging-campaign-configure/components/configure-form/configure-form.types';

type UseMessagingCampaignCreatePageControllerParams = {
  onCompleted: (mutation: CreateMessagingCampaignMutation) => void;
  onError?: (error: ApolloError) => void;
};

export const useMessagingCampaignCreatePageController = ({
  onCompleted,
  onError,
}: UseMessagingCampaignCreatePageControllerParams) => {
  const [createMessagingCampaign, { loading: isLoading }] = useCreateMessagingCampaign({
    onCompleted,
    onError: (error: ApolloError) => {
      onError?.(error);
    },
  });

  const handleSubmit = (values: MessagingCampaignConfigureFormValues) => {
    return createMessagingCampaign({
      variables: {
        input: {
          title: values.title,
          description: values.description || undefined,
          channelsConfig: getUpdateChannelsConfigInput(values),
        },
      },
    });
  };

  return {
    handleSubmit,
    isLoading,
  };
};
